export default __webpack_public_path__ + "static/media/GES_D.bd23d778.png";